export const ALL_OT2_DECK_LAYERS = [
  'fixedBase',
  'fixedTrash',
  'doorStops',
  'metalFrame',
  'removableDeckOutline',
  'slotRidges',
  'slotNumbers',
  'calibrationMarkings',
  'removalHandle',
  'screwHoles',
] as const
